import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, Card, CardContent, CardHeader, Typography, useTheme } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import { useStyles } from './styles';

const SolutionsBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Box width="100%" sx={styles.container} id="solutions">
      <Box width="100%" sx={styles.box}>
        {/* <Typography variant="overline" color="grey.500">
          {t('landing.big_purple_dot')} {t('landing.recruitment')}
        </Typography> */}
        <Typography sx={styles.bigText}>{t('landing.our_features')}</Typography>

        <Box width="100%" sx={styles.cardBox}>
          <Card sx={styles.card}>
            <SvgIconStyle src="/icons/color/ic_design.svg" sx={styles.iconBlue} />
            <CardHeader
              title={t('landing.crm')}
              titleTypographyProps={{ fontSize: '20px', fontWeight: 700 }}
            />
            <CardContent sx={styles.text}>{t('landing.crm_body')}</CardContent>
          </Card>

          <Card sx={styles.card}>
            <SvgIconStyle src="/icons/iconly/light-outline/3_user.svg" sx={styles.iconRed} />
            <CardHeader
              title={t('landing.general_info_title')}
              titleTypographyProps={{ fontSize: '20px', fontWeight: 700 }}
            />
            <CardContent sx={styles.text}>{t('landing.general_info_body')}</CardContent>
          </Card>

          <Card sx={styles.card}>
            <SvgIconStyle src="/icons/iconly/light-outline/document.svg" sx={styles.iconOrange} />
            <CardHeader
              title={t('landing.lo_map_title')}
              titleTypographyProps={{ fontSize: '20px', fontWeight: 700 }}
            />
            <CardContent sx={styles.text}>{t('landing.lo_map_body')}</CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default SolutionsBlock;
